<template>
  <div>
    <div
      class="job-box"
      @click="showDescriptionPageOnCardClick ? descriptionPage() : ''"
    >
      <div class="container-job">
        <div
          @click="showDescriptionPage ? descriptionPage() : ''"
          class="opportunity-title"
        >
          <h2>
            <wheelchair-accessibility-icon v-if="opportunity.pcd" />
            {{ opportunity.title }}
          </h2>

          <p v-if="opportunity.address">
            {{ opportunity.address.city }}
          </p>
        </div>

        <img src="@/assets/images/arrow-right-jobs.svg" alt="seta apontanda para a direita" />
      </div>
    </div>
  </div>
</template>

<script>
  import WheelchairAccessibilityIcon from "vue-material-design-icons/WheelchairAccessibility.vue";
  import ModalJobBox from "./ModalJobBox.vue";

  export default {
    name: "JobBox",
    props: {
      opportunity: Object,
      id: Number,
      btnSubscriptionText: String,
      showModalKnowMoreButton: Boolean,
      showDescriptionPage: Boolean,
      knowMoreText: String,
      customSubscriptionPageRoute: String,
      showDescriptionPageOnCardClick: Boolean,
    },
    computed: {
      title() {
        return this.$helpers.toTitle(this.opportunity.title);
      },
      subscriptionStep() {
        const id = this.opportunity.id;
        const findSubscription = this.$store.state.opportunities.subscriptions.find(
          (subs) => subs.opportunityId == id
        );

        if (findSubscription) {
          return findSubscription.step;
        }

        return '';
      },
      enrolled() {
        const uri = this.opportunity.links.subscription.split("/");
        const name = uri[uri.length - 1];
        const id = name.match(/\d+/)[0];
        
        return !!this.$store.state.opportunities.subscriptions.find(
          (subs) => subs.opportunityId == id
        );
      },
      timeLeft() {
        const now = this.$moment();
        const published_at = this.$moment(this.opportunity.published_at).startOf(
          "day"
        );
        const expired_at = this.$moment(this.opportunity.expired_at).endOf("day");
        const total_days = expired_at.diff(published_at, "days");
        const time_left = expired_at.diff(now, "days");
        const percent = 100 - (100 * time_left) / total_days;
        
        return {
          percentage: percent > 100 ? 100 : percent,
          days: time_left < 0 ? 0 : time_left,
        };
      },
    },
    components: {
      WheelchairAccessibilityIcon,
      ModalJobBox,
    },
    methods: {
      descriptionPage() {
        this.$router.push({ name: "job", params: { id: this.opportunity.slug } });
      },
      hideModal(ref) {
        this.$refs[ref].hide();
      },
    },
  };
</script>

<style lang="scss">
  .job-box {
    border: none;
    .container-job {
      cursor: pointer;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 20px;
      .opportunity-title {
        display: flex;
        flex-direction: column;
        gap: 8px;
        h2 {
          font-size: 20px;
          line-height: 26px;
          font-weight: 500;
          color: rgba(34, 35, 43, 1);
        }
        p {
          font-size: 14px;
          line-height: 21px;
          font-weight: 400;
          color: rgba(110, 112, 119, 1);
        }
      }
    }
  }
</style>
